import datacentral from '@/utils/axios/datacentral'
import {
    DayOffBODApprove,
    DayOffLeaderApprove,
    DayOffNewPayload,
    DayOffReject,
    DayOffUpdate,
} from '../types/payload'
import { DayOffResponse, DayOffStats, DayOffSummary } from '../types/response'
import {
    ErrorResponse,
    ResponseArray,
    ResponseObject,
    QueryParams,
} from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import qs from 'query-string'

export const getDayOffs = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<DayOffResponse>>(
        `/employees/day_offs/list?page=${payload?.page}&page_size=${payload?.page_size}${payload?.q ? `&q=${payload?.q}` : ''}${payload?.filters ? `&filters=${payload?.filters}` : ''}`
    )
    return response?.data
}

/** Get all day offs for HRM (with sorting support) */
export const getDayOffsList = async (params: QueryParams) => {
    const response = await datacentral.get<ResponseArray<DayOffResponse>>(
        `/employees/day_offs/list?${qs.stringify(params)}`
    )
    return response?.data
}

export const getDayOffByEmployeeID = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<DayOffResponse>>(
        `/employees/day_offs?page=${payload?.page}&page_size=${payload?.page_size}${payload?.q ? `&q=${payload?.q}` : ''}${payload?.filters ? `&filters=${payload?.filters}` : ''}`
    )
    return response?.data
}

/** Get day offs for employee (with sorting support) */
export const getDayOffsEmployeeList = async (params: QueryParams) => {
    const response = await datacentral.get<ResponseArray<DayOffResponse>>(
        `/employees/day_offs?${qs.stringify(params)}`
    )
    return response?.data
}

export const createDayOff = async (
    payload: DayOffNewPayload
): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.post('/employees/day_offs', payload)
    return response.data
}

export const updateDayOff = async (payload: {
    id: number
    dayOff: DayOffUpdate
}): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.put(
        `/employees/day_offs/${payload?.id}`,
        payload?.dayOff
    )
    return response.data
}

export const cancelDayOff = async (
    id: number
): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.put(`/employees/day_offs/${id}/cancel`)
    return response.data
}

export const approveBodDayOff = async (payload: {
    id: number
    feedback: DayOffBODApprove
}): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.put(
        `/employees/day_offs/${payload.id}/bod/approve`,
        payload?.feedback
    )
    return response.data
}

export const approveLeadDayOff = async (payload: {
    id: number
    feedback: DayOffLeaderApprove
}): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.put(
        `/employees/day_offs/${payload.id}/lead/approve`,
        payload?.feedback
    )
    return response.data
}

export const rejectDayOff = async (payload: {
    id: number
    feedback: DayOffReject
}): Promise<ResponseObject<DayOffResponse> | ErrorResponse> => {
    const response = await datacentral.put(
        `/employees/day_offs/${payload.id}/reject`,
        payload?.feedback
    )
    return response.data
}

// export const getDayOffsByDepartment = async (payload: DayOffs) => {
//     const response = await (datacentral.get) <ResponseResult> (`/employees/day_offs/department?page=${payload?.page}&page_size=${payload?.page_size}`)
//     return response?.data
// }

export const getDayOffByID = async (id: number) => {
    const response = await datacentral.get<ResponseObject<DayOffResponse>>(
        `/employees/day_offs/${id}`
    )
    return response?.data
}
export const getDayOffSummary = async () => {
    const response = await datacentral.get<ResponseObject<DayOffSummary>>(
        `/employees/day_offs/statistical`
    )
    return response.data
}

/** Get day off stats for HRM (based on filters) */
export const getDayOffStats = async (params: QueryParams) => {
    const response = await datacentral.get<ResponseObject<DayOffStats>>(
        `/employees/day_offs/stats?${qs.stringify(params)}`
    )
    return response.data
}
